import { useQueryClient } from '@tanstack/react-query';

import useAIJobChannel from 'hooks/useAIJobChannel';
import { clone } from 'lib/util';
import Attachment from 'models/Attachment';
import Review, { ReviewType } from 'models/Review';
import Authorization from 'models/reviews/Authorization';
import Referral from 'models/reviews/Referral';
import { authorizationQueryKeys, referralQueryKeys } from 'services/api/reviews';

type ReviewAttachmentJobSubscriberProps = {
  attachment: Attachment;
  reviewId: string;
  reviewType: ReviewType;
};

export default function ReviewAttachmentJobSubscriber({
  attachment,
  reviewId,
  reviewType,
}: ReviewAttachmentJobSubscriberProps) {
  const queryClient = useQueryClient();
  const job = attachment.extractDataAIJob;

  const queryKeys = reviewType === ReviewType.AUTHORIZATION ? authorizationQueryKeys : referralQueryKeys;
  const klass = reviewType === ReviewType.AUTHORIZATION ? Authorization : Referral;

  useAIJobChannel({
    aiJobId: job?.isProcessing ? job.id : undefined,
    onMessageReceived: (updatedJob) => {
      if (updatedJob.isProcessing) return;
      queryClient.setQueryData(queryKeys.show({ id: reviewId }), (oldData: Review) => {
        if (!oldData?.attachments) return oldData;

        const updatedAttachments = oldData.attachments.map((att) => {
          if (att.id === updatedJob.aiJobbableId) att.extractDataAIJob = updatedJob;
          return att;
        });

        return clone(klass, oldData, { attachments: updatedAttachments });
      });
    },
  });

  return null;
}
